// extracted by mini-css-extract-plugin
export default {"missingTrafficLogRow":"citations_missingTrafficLogRow__GVYkS"};